module.exports = __webpack_public_path__ + "static/portfolio_1-b7c2a56b17f344fee6fcd94652a25368.png";